var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9226 9.19401C1.9226 9.0684 1.97703 8.93442 2.0859 8.79206L7.79487 1.66369C7.89955 1.52971 8.0126 1.44806 8.13402 1.41875C8.25963 1.38944 8.37059 1.402 8.46689 1.45643C8.56738 1.50668 8.63646 1.59042 8.67415 1.70765C8.71602 1.82489 8.70555 1.96306 8.64274 2.12217L6.77115 7.20938H10.3196C10.4536 7.20938 10.5625 7.25125 10.6462 7.33499C10.73 7.41454 10.7718 7.51503 10.7718 7.63645C10.7718 7.76625 10.7174 7.90023 10.6085 8.0384L4.89956 15.1731C4.79489 15.3029 4.67974 15.3824 4.55413 15.4117C4.43271 15.4452 4.32176 15.4347 4.22127 15.3803C4.12497 15.3301 4.05588 15.2463 4.01401 15.1291C3.97633 15.0119 3.98889 14.8716 4.05169 14.7083L5.92328 9.62109H2.3748C2.24082 9.62109 2.13195 9.58131 2.04821 9.50176C1.96447 9.41802 1.9226 9.31544 1.9226 9.19401Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Lightning.ada5079c59b79b08bcaab4331b737f6e.svg";